module.exports = __webpack_public_path__ + "static/15-d4284e9b8bf546c76373137cc39bd41e.webp";